import React from 'react';
import Box from '@bit/knotchinc.web-react-components.box';
import {
  StyledSearchInput,
  SearchContainer,
  InputLabel } from './styled';

class SearchTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.searchRef = React.createRef();
  }

  addText(newText) {
    this.props.onUpdate(newText);
  }

  render() {
    const { selected, label } = this.props;

    return (<Box mb="20px">
      <SearchContainer onClick={() => this.searchRef.current.focus()}>
        <Box display="inline-block" position="relative" pl="10px">
          <StyledSearchInput
            ref={this.searchRef}
            placeholder="Add more..."
            value={selected}
            onChange={e => this.addText(e.target.value)}
          />
        </Box>
      </SearchContainer>
      <InputLabel>{label}</InputLabel>
    </Box>);
  }
}

SearchTextInput.defaultProps = {
  selected: [],
};

export default SearchTextInput;
